import { useState } from 'react'

import { formatPhoneNumber } from '../../../../utils/helpers'
import styles from './CheckRow.module.scss'

export const CheckTextRow = ({
  title,
  checked = false,
  name,
  setValue,
  setLength,
  defaultVal
}) => {
  const [isChecked, setChecked] = useState(checked)
  const [val, setVal] = useState(defaultVal?.substring(0, defaultVal.length - 1))

  function handleCheckToggle(e) {
    if (!e.target.checked) {
      setVal(defaultVal.substring(0, defaultVal.length - 1))
      setValue(name, false)
    } else {
      setValue(name, true)
      setLength(name, val.length)
    }
    setChecked(e.target.checked)
  }

  function handleInputChange(e) {
    if (
      defaultVal
        ?.toLowerCase()
        ?.substring(0, defaultVal.length - 1)
        ?.startsWith(e.target.value.toLowerCase())
    ) {
      setVal(e.target.value)

      if (isChecked) {
        setValue(name, true)
        setLength(name, e.target.value.length)
      }
    }
  }

  return (
    <div className={checked ? styles.checkedTextRow : styles.checkTextRow}>
      <label className={checked ? styles.checkedRow : styles.checkRow}>
        <input type="checkbox" onChange={handleCheckToggle} checked={isChecked} />
        <div className={styles.label}>{title}</div>
      </label>
      <input
        name={name}
        disabled={!isChecked}
        className={styles.checkTextInput}
        type="text"
        value={val}
        onChange={handleInputChange}
        autoComplete="off"
      />
    </div>
  )
}

const CheckRow = ({ value, setValue, checked = false, name, detail }) => {
  if (!value) {
    return null
  }

  let formattedVal = value

  if (name && name.toLowerCase().includes('phone')) {
    formattedVal = formatPhoneNumber(value)
  }

  if (name && name.toLowerCase().includes('email')) {
    formattedVal = value.toLowerCase()
  }

  return (
    <label className={checked ? styles.checkedRow : styles.checkRow}>
      <input
        name={name}
        type="checkbox"
        onChange={e => setValue(name, e.target.checked)}
        checked={checked}
      />
      <div className={styles.label}>
        {name && name.toLowerCase().includes('domain') && (
          <span className={styles.gray}>anything</span>
        )}
        <div>
          <p className={styles.value}>{formattedVal}</p>
          {detail && <p className={styles.detail}>{detail}</p>}
        </div>
      </div>
    </label>
  )
}

export default CheckRow
